var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tags-field" },
    [
      _vm.externalLabel
        ? _c("div", { staticClass: "az-text-label" }, [
            _vm._v(" " + _vm._s(_vm.label))
          ])
        : _vm._e(),
      !_vm.readonly
        ? _c("v-text-field", {
            attrs: {
              label: _vm.externalLabel ? "" : _vm.label,
              placeholder: _vm.placeholder,
              outlined: _vm.outlined,
              "hide-details": ""
            },
            on: {
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.addTag($event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function() {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "primary" },
                          on: { click: _vm.addTag }
                        },
                        [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3476882275
            ),
            model: {
              value: _vm.tag,
              callback: function($$v) {
                _vm.tag = $$v
              },
              expression: "tag"
            }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center mt-2",
          staticStyle: { "flex-wrap": "wrap" }
        },
        [
          !_vm.readonly
            ? _c("p", { staticClass: "subtitle mb-0 mr-2" }, [
                _vm._v(" " + _vm._s(_vm.textType) + " ")
              ])
            : _vm._e(),
          _vm._l(_vm.value, function(t, i) {
            return _c(
              "v-chip",
              {
                key: i,
                class: { "mr-1 mt-1": !_vm.noSpacing },
                attrs: {
                  close: !_vm.readonly,
                  small: _vm.small,
                  "x-small": _vm.xSmall
                },
                on: {
                  "click:close": function($event) {
                    return _vm.removeTag(t)
                  }
                }
              },
              [_vm._v(" " + _vm._s(t) + " ")]
            )
          }),
          !(_vm.value || []).length && !_vm.readonly
            ? _c("p", { staticClass: "mb-0" }, [
                _c("small", { staticClass: "text-secondary" }, [
                  _vm._v(" " + _vm._s(_vm.defaultMessage) + " ")
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }